import { render, staticRenderFns } from "./TagsTable.vue?vue&type=template&id=e9798e34&scoped=true&"
import script from "./TagsTable.vue?vue&type=script&lang=ts&"
export * from "./TagsTable.vue?vue&type=script&lang=ts&"
import style0 from "./TagsTable.vue?vue&type=style&index=0&id=e9798e34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9798e34",
  null
  
)

export default component.exports